import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {useLocation, useParams} from "react-router-dom";
import {Button, Form, Select} from "antd";
import {MaskedInput} from "antd-mask-input";
import {
    resetAction,
    restoreAction,
} from "../../redux/actions/loginActions";
import store from "../../redux/store";
import moment from "moment";
import axios from "axios";
import {api} from "../../config";

const {Option} = Select;

const Top = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 45px;

  h1 {
    margin: 0 12px 0 0;

    font-weight: 600;
    font-size: 28px;
    line-height: 34px;
    display: flex;
    align-items: center;

    color: #311C1C;
  }

  a {
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;

    display: flex;
    align-items: center;

    color: #5B77CB;
  }
`;

const StyledCreateProfilePage = styled.div`
  display: flex;
  flex-direction: column;
  padding: 65px 18.75% 220px 18.75%;

  @media screen and (max-width: 1919px) {
    padding: 65px 20px 220px 20px;
  }
  
  .ant-form-item {
    margin: 0;
  }

  .askBlock {
    margin-top: 40px;

    .askAgain {
      font-weight: 500;
      font-size: 18px;
      line-height: 140%;
      text-decoration-line: underline;

      color: #5B77CB;
      cursor: not-allowed;

      &.available {
        cursor: pointer;
      }
    }

    .timer {
      font-weight: 400;
      font-size: 18px;
      line-height: 140%;


      color: #8A8A8A;
    }
  }

  .ant-form {
    .ant-input {
      font-weight: 400;
      font-size: 18px;
      line-height: 140%;


      height: auto;
      padding: 16px 10px;

      color: #000000;
    }

    label {
      font-weight: 400;
      font-size: 18px;
      line-height: 140%;

      color: #8A8A8A;

      &.ant-checkbox-wrapper {
        font-weight: 400;
        font-size: 18px;
        line-height: 140%;

        color: #000000;
      }
    }
  }


  .ant-btn {
    font-weight: 500;
    font-size: 18px;
    line-height: 140%;
    color: #FFFFFF;
    border: none;
    padding: 17px 28px;
    height: auto;
    background: #5B77CB;
    border-radius: 4px;
    margin-top: 32px;
    margin-bottom: 24px;
  }
`;


function VerifyPage() {
    const waitingTime = 60;
    const {phone, email} = useParams();
    const location = useLocation();

    const controller = new AbortController();

    const [time, setTime] = useState<number>(waitingTime)
    const [againAvailable, setAgainAvailable] = useState<boolean>(false);

    const [checkId, setCheckId] = useState<string>("");
    const [callPhone, setCallPhone] = useState<string>("");

    const [formRef] = Form.useForm();

    useEffect(() => {
        if (email) return;

        // @ts-ignore
        if (location.state && location.state.verificationData) {
            // @ts-ignore
            setCheckId(location.state.verificationData.check_id);
            // @ts-ignore
            setCallPhone(location.state.verificationData.call_phone);
        } else if (phone) {
            axios.get(`${api}/recovery/phone/${phone}`).then(({data}) => {
                setCheckId(data.check_id);
                setCallPhone(data.call_phone);
            }).catch(() => {
                // Handle error
            })
        }
    }, [location.state, phone, email])

    useEffect(() => {
        setTime(waitingTime);
    }, [againAvailable])

    useEffect(() => {
        let interval: any;
        if (!againAvailable) {
            interval = setInterval(() => {
                setTime((time) => time - 1)
            }, 1000)
        }

        if (time === 0) {
            clearInterval(interval);
            setAgainAvailable(true);
        }


        return () => {
            if (interval)
                clearInterval(interval);
        }
    }, [time, againAvailable])


    return (
        <StyledCreateProfilePage>
            <Top><h1>{email ? "Введите код" : "Подтверждение звонком"}</h1></Top>
            <Form form={formRef} requiredMark={false} layout={"vertical"} onFinish={({code}) => {
                store.dispatch(resetAction(email !== undefined ? "email" : "phone", email !== undefined ? email : phone, email !== undefined ? code : checkId, controller.signal))
            }}>
                {email !== undefined ? <Form.Item name={"code"} rules={[{required: true}, {
                    validator: (_, value) => {
                        if (value !== undefined && value.indexOf("_") !== -1) {
                            return Promise.reject(new Error("Поле должно быть заполнено полностью!"))
                        } else {
                            return Promise.resolve()
                        }
                    }
                }]} style={{display: 'inline-block'}}
                           label={"Укажите код который пришел на вашу почту"}>
                    <MaskedInput style={{width: 165}} mask={'0000'} onChange={({target: {value}}) => {
                        if (!value.includes("_")) {
                            formRef.submit()
                        }
                    }}/>
                </Form.Item> :
                    <div style={{marginBottom: 24}}>
                        <p style={{fontSize: 18, lineHeight: '140%', color: '#000'}}>
                            Для подтверждения позвоните на номер <b>{callPhone}</b>.<br/>
                            Звонок бесплатный, отвечать не нужно.
                        </p>
                    </div>
                }

                <Form.Item className={"askBlock"}>
                    <span className={`askAgain ${againAvailable ? "available" : ""}`} onClick={() => {
                        if (againAvailable) {
                            setAgainAvailable(false);
                            if (email) {
                                store.dispatch(restoreAction("email", email))
                            } else {
                                axios.get(`${api}/recovery/phone/${phone}`).then(({data}) => {
                                    setCheckId(data.check_id);
                                    setCallPhone(data.call_phone);
                                })
                            }
                        }
                    }}>Запросить {email ? "код" : "номер"} повторно</span> {!againAvailable && <span
                    className={"timer"}>через {moment.utc(time * 1000).format("mm:ss")}</span>}
                </Form.Item>

                {!email && <Form.Item>
                    <Button htmlType={"submit"}>Я позвонил</Button>
                </Form.Item>}
            </Form>
        </StyledCreateProfilePage>
    );
}

export default VerifyPage;